import { render, staticRenderFns } from "./FormulateVSelect.vue?vue&type=template&id=94da762c"
import script from "./FormulateVSelect.vue?vue&type=script&lang=ts"
export * from "./FormulateVSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports